import { render, staticRenderFns } from "./ExceptionalRequest.vue?vue&type=template&id=2040b663&scoped=true"
import script from "./ExceptionalRequest.vue?vue&type=script&lang=js"
export * from "./ExceptionalRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2040b663",
  null
  
)

export default component.exports